/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface GetHierarchyUsageRequest {
    startTime?: string;
    endTime?: string;
}

export interface GetUsageRequest {
    startTime?: string;
    endTime?: string;
    featureId?: string;
}

/**
 * UsageApi - interface
 * 
 * @export
 * @interface UsageApiInterface
 */
export interface UsageApiInterface {
    /**
     * Returns usage rolled up for tenant hierarchy (current tenant + children). Requires multi_tenant_relationships entitlement.
     * @summary Get hierarchy usage
     * @param {string} [startTime] Start of period (ISO-8601). Defaults to start of current month.
     * @param {string} [endTime] End of period (ISO-8601). Defaults to now.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsageApiInterface
     */
    getHierarchyUsageRaw(requestParameters: GetHierarchyUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns usage rolled up for tenant hierarchy (current tenant + children). Requires multi_tenant_relationships entitlement.
     * Get hierarchy usage
     */
    getHierarchyUsage(requestParameters: GetHierarchyUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns usage summary for the current tenant. Optional featureId filter.
     * @summary Get current tenant usage
     * @param {string} [startTime] Start of period (ISO-8601). Defaults to start of current month.
     * @param {string} [endTime] End of period (ISO-8601). Defaults to now.
     * @param {string} [featureId] Optional feature ID filter. If omitted, returns usage grouped by feature.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsageApiInterface
     */
    getUsageRaw(requestParameters: GetUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns usage summary for the current tenant. Optional featureId filter.
     * Get current tenant usage
     */
    getUsage(requestParameters: GetUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class UsageApi extends runtime.BaseAPI implements UsageApiInterface {

    /**
     * Returns usage rolled up for tenant hierarchy (current tenant + children). Requires multi_tenant_relationships entitlement.
     * Get hierarchy usage
     */
    async getHierarchyUsageRaw(requestParameters: GetHierarchyUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/usage/hierarchy`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns usage rolled up for tenant hierarchy (current tenant + children). Requires multi_tenant_relationships entitlement.
     * Get hierarchy usage
     */
    async getHierarchyUsage(requestParameters: GetHierarchyUsageRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getHierarchyUsageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns usage summary for the current tenant. Optional featureId filter.
     * Get current tenant usage
     */
    async getUsageRaw(requestParameters: GetUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        if (requestParameters['featureId'] != null) {
            queryParameters['featureId'] = requestParameters['featureId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/usage`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns usage summary for the current tenant. Optional featureId filter.
     * Get current tenant usage
     */
    async getUsage(requestParameters: GetUsageRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getUsageRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
